import cx from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CircularLoader({
  className
}) {
  return /*#__PURE__*/_jsx("div", {
    className: cx('circular-loader', className),
    children: /*#__PURE__*/_jsx("span", {
      className: "circular-loader__text",
      children: "Loading..."
    })
  });
}